/** SVD Ad Report client: the server keeps a cleaned copy of the agency's Google Doc. */

export interface ReportWeek { id: string; label: string }
export interface ReportMeta {
  docId: string;
  ready: boolean;
  stale?: boolean;
  refreshing?: boolean;
  fetchedAt?: string | null;
  lastError?: string | null;
  weeks: ReportWeek[];
}

export const VIEW_URL = '/api/ad-report/view';
export const DOC_URL = (docId: string): string => `https://docs.google.com/document/d/${docId}/edit`;

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api/ad-report${path}`, { credentials: 'include', ...init });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((body && (body.message || body.error)) || `Request failed (${res.status})`);
  return body.data as T;
}

export const fetchMeta = (): Promise<ReportMeta> => call<ReportMeta>('/meta');
export const requestRefresh = (): Promise<unknown> => call('/refresh', { method: 'POST' });
